// extracted by mini-css-extract-plugin
module.exports = {"count":"styles__count___1gvnR","header":"styles__header___Cfypf","enclosedHeader":"styles__enclosedHeader___1w4QS styles__header___Cfypf","separator":"styles__separator___9Ro36"};